import { Translate } from '@chipinside/translate'
import { Box, Grid, SxProps, Theme, Typography } from '@mui/material'
import { uniqueId } from 'lodash'

import { Icon } from '#/components/Icon'
import Colors from '#/styles/Colors'

type Props = {
  row: {
    identifier: string
    line: number
    output?: { text: string; status: string }[]
    status: {
      status: string
      text: string
    }
  }
  sx?: SxProps<Theme>
  showStatus?: boolean
}

export default function ImportResultItem({ row, showStatus, sx }: Props) {
  const { identifier, line, output, status } = row
  return (
    <Box key={uniqueId(identifier)} sx={sx}>
      <Grid container sx={{ display: 'flex', flexGrow: 1, p: 1 }}>
        <Grid size={{ sm: 5, xs: 12 }}>
          {showStatus ? (
            <Typography variant="subtitle2" style={{ color: statusColor(status.status) }}>
              {status.text}
            </Typography>
          ) : null}
          <Typography sx={{ color: Colors.feedback.neutral.color, fontSize: 12 }}>
            {Translate({ messageKey: 'identification', suffix: ': ' })}
            <span>{identifier ?? Translate({ messageKey: 'without_information' })}</span>
          </Typography>
          <Typography sx={{ color: Colors.feedback.neutral.color, fontSize: 12 }}>
            {Translate({ messageKey: 'row', suffix: ': ' })}
            <span>{line ?? '-'}</span>
          </Typography>
        </Grid>
        <Grid size={{ sm: 7, xs: 12 }}>
          {output?.map(item => (
            <Typography
              key={uniqueId(item.text)}
              sx={{ color: statusColor(item.status), fontSize: 12 }}
            >
              {item.text}
            </Typography>
          ))}
        </Grid>
      </Grid>
    </Box>
  )
}

export function statusColor(status) {
  switch (status) {
    case 'neutral':
      return Colors.feedback.neutral.color

    case 'failed':
    case 'negative':
      return Colors.feedback.error.color

    case 'success':
    case 'positive':
      return Colors.feedback.success.color

    case 'success-with-warnings':
      return Colors.feedback.warning.color

    default:
      return Colors.feedback.neutral.color
  }
}

export function statusIcon(status) {
  switch (status) {
    case 'failed':
      return props => <Icon size="large" name="x" {...props} />

    case 'success':
      return props => <Icon size="large" name="check" {...props} />

    case 'success-with-warnings':
      return props => <Icon size="large" name="circle-alert" {...props} />

    default:
      break
  }
}

export function statusText(text) {
  switch (text) {
    case 'failed':
      return Translate({ messageKey: 'unprocessed' })

    case 'success':
      return Translate({ messageKey: 'processed_successfully' })

    case 'success-with-warnings':
      return Translate({ messageKey: 'processed_with_errors' })

    default:
      break
  }
}
